(function () {
  const SWIPER_SRC = 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.js';

  function loadSwiper() {
    if (window.Swiper) return Promise.resolve();
    if (window.tpSwiperLoadPromise) return window.tpSwiperLoadPromise;

    window.tpSwiperLoadPromise = new Promise((resolve, reject) => {
      const existingScript = document.querySelector('script[data-tp-swiper]');

      if (existingScript) {
        existingScript.addEventListener('load', resolve, { once: true });
        existingScript.addEventListener('error', reject, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = SWIPER_SRC;
      script.defer = true;
      script.dataset.tpSwiper = 'true';
      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });

    return window.tpSwiperLoadPromise;
  }

  if (!customElements.get('tp-video-slides-component')) {
    class TpVideoSlidesComponent extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.bindVideoControls();
        this.initializeSwiper();
      }

      disconnectedCallback() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }

        if (this.abortController) this.abortController.abort();
      }

      async initializeSwiper() {
        try {
          await loadSwiper();
        } catch (error) {
          this.dataset.swiperError = 'true';
          return;
        }

        if (!this.isConnected || !window.Swiper) return;

        const swiperElement = this.querySelector('[data-tp-video-swiper]');
        if (!swiperElement) return;

        if (this.swiper) this.swiper.destroy(true, true);

        const paginationElement = this.querySelector('[data-tp-video-pagination]');
        const previousElement = this.querySelector('[data-tp-video-prev]');
        const nextElement = this.querySelector('[data-tp-video-next]');
        const slideCount = this.querySelectorAll('.swiper-slide').length;
        const desktopSlides = this.getNumber('slidesDesktop', 4);

        this.swiper = new window.Swiper(swiperElement, {
          slidesPerView: this.getNumber('slidesMobile', 1),
          spaceBetween: this.getNumber('spaceMobile', 16),
          centeredSlides: this.dataset.centeredMobile === 'true',
          watchOverflow: true,
          threshold: 8,
          loop: this.dataset.loop === 'true' && slideCount > desktopSlides,
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
          autoplay:
            this.dataset.autoplay === 'true'
              ? {
                  delay: this.getNumber('autoplayDelay', 3000),
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }
              : false,
          pagination: paginationElement
            ? {
                el: paginationElement,
                clickable: true,
              }
            : false,
          navigation:
            previousElement && nextElement
              ? {
                  prevEl: previousElement,
                  nextEl: nextElement,
                }
              : false,
          breakpoints: {
            750: {
              slidesPerView: this.getNumber('slidesTablet', 2.3),
              spaceBetween: this.getNumber('spaceTablet', 16),
              centeredSlides: false,
            },
            990: {
              slidesPerView: desktopSlides,
              spaceBetween: this.getNumber('spaceDesktop', 24),
              centeredSlides: false,
            },
            1280: {
              slidesPerView: desktopSlides,
              spaceBetween: this.getNumber('spaceDesktopLarge', 32),
              centeredSlides: false,
            },
          },
        });
      }

      bindVideoControls() {
        const signal = this.abortController.signal;

        this.querySelectorAll('[data-tp-video-toggle]').forEach((button) => {
          button.addEventListener(
            'click',
            (event) => {
              event.preventDefault();

              const card = button.closest('[data-tp-video-card]');
              const video = card ? card.querySelector('video') : null;
              if (!card || !video) return;

              if (video.paused) {
                this.pauseOtherVideos(video);
                video.controls = true;
                video.muted = false;
                video.play().catch(() => {
                  video.muted = true;
                  video.play().catch(() => {});
                });
              } else {
                video.pause();
              }
            },
            { signal }
          );
        });

        this.querySelectorAll('video').forEach((video) => {
          const card = video.closest('[data-tp-video-card]');
          const toggle = card ? card.querySelector('[data-tp-video-toggle]') : null;

          video.addEventListener(
            'play',
            () => {
              if (card) card.classList.add('is-playing');
              if (toggle) toggle.setAttribute('aria-label', toggle.dataset.pauseLabel || 'Pausar video');
            },
            { signal }
          );

          video.addEventListener(
            'pause',
            () => {
              if (card) card.classList.remove('is-playing');
              if (toggle) toggle.setAttribute('aria-label', toggle.dataset.playLabel || 'Reproduzir video');
            },
            { signal }
          );
        });
      }

      pauseOtherVideos(currentVideo) {
        this.querySelectorAll('video').forEach((video) => {
          if (video !== currentVideo) video.pause();
        });
      }

      getNumber(name, fallback) {
        const value = Number(this.dataset[name]);
        return Number.isFinite(value) ? value : fallback;
      }
    }

    customElements.define('tp-video-slides-component', TpVideoSlidesComponent);
  }
})();
